// extracted by mini-css-extract-plugin
export default {"Container":"style_Container__4Ro2s","hidden":"style_hidden__0fYN2"};